import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SensorObject } from '../asp/SensorObject';
import { SensorCoreObject } from '../../core/app/asp/SensorCoreObject';
import * as aro from '@core_n/aro/aro';
import { DistanceFieldComponent } from './../../core/app/aro/fields/unique-fields/distance-field/distance-field.component';
import { BasicFieldComponent } from './../../core/app/aro/fields/basic-fields/basic-field.component';
import { BasicFieldNumberComponent } from './../../core/app/aro/fields/basic-fields-numbers/basic-field-number.component';
import { FieldWriteNumberComponent } from './../../core/app/aro/fields/field-write-number.component';
import { FieldWriteComponent } from './../../core/app/aro/fields/field-write.component';
import { CheckBoxFieldComponent } from './../../core/app/aro/fields/checkbox-field/checkbox-field.component';
import * as msgs from './../msg/projMsgs';
import { from } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { accelerationUnits, DEG_TO_RAD } from '@core_n/common/units';
import { CoordsComponent } from '@core_n/aro/components/coords/coords.component';
import { Point } from '@core_n/common/Point';
import * as projEnums from './../common/projEnums';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import * as projMsgs from './../../app/msg/projMsgs';
import { IAro, AppInjector } from './../../core/app/common/inject';
import { AlertPolygonObject } from './../../core/app/alert-polygon/alert-polygon.component';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as utils from './../../core/app/common/utils';
import { MatDialogRef } from '@angular/material/dialog';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { Animations } from './../../core/app/Animations';
import { userSettings } from './../../core/app/common/settings';
import { sensorsPool } from '@core_n/asp/aspObjects';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
const REFRESH_CORR_PLOTS_RATE = 5; // once every 5 refresh cycles

@Component({
  templateUrl: 'aro-sensor-tab-details.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class AroSensorTabDetailsComponent extends ZIndexMngr implements OnInit, AfterViewInit {
  static readonly DIALOG_ID = 'createSensor';

  // MY CHILDREN ARE HERE!
  @ViewChild('sic') sic: FieldWriteNumberComponent;
  @ViewChild('sac') sac: FieldWriteNumberComponent;
  @ViewChild('logiConn') logiConn: CheckBoxFieldComponent;
  @ViewChild('sensorName') sensorName: FieldWriteComponent;
  @ViewChild('sensorLetter') sensorLetter: FieldWriteComponent;
  @ViewChild('scanTime') scanTime: FieldWriteNumberComponent;
  @ViewChild('minRange') minRange: FieldWriteNumberComponent;
  @ViewChild('maxRange') maxRange: FieldWriteNumberComponent;
  @ViewChild('maxHeight') maxHeight: FieldWriteNumberComponent;
  @ViewChild('SSRCapable') SSRCapable: CheckBoxFieldComponent;
  @ViewChild('SSRMinRange') SSRMinRange: FieldWriteNumberComponent;
  @ViewChild('SSRMaxRange') SSRMaxRange: FieldWriteNumberComponent;
  @ViewChild('PSRReg') PSRReg: CheckBoxFieldComponent;
  @ViewChild('SSRReg') SSRReg: CheckBoxFieldComponent;
  @ViewChild('ALT_REGISTERED') ALT_REGISTERED: CheckBoxFieldComponent;
  @ViewChild('azimuthBias') azimuthBias: FieldWriteNumberComponent;
  @ViewChild('rangeBias') rangeBias: FieldWriteNumberComponent;
  @ViewChild('heightBias') heightBias: FieldWriteNumberComponent;
  @ViewChild('elevationBias') elevationBias: FieldWriteNumberComponent;
  @ViewChild('SSRAzimuthBias') SSRAzimuthBias: FieldWriteNumberComponent;
  @ViewChild('SSRRangeBias') SSRRangeBias: FieldWriteNumberComponent;
  @ViewChild('locXBias') locXBias: FieldWriteNumberComponent;
  @ViewChild('locYBias') locYBias: FieldWriteNumberComponent;
  @ViewChild('locConfidence') locConfidence: CheckBoxFieldComponent;
  @ViewChild('locBiasXError') locBiasXError: FieldWriteNumberComponent;
  @ViewChild('locBiasYError') locBiasYError: FieldWriteNumberComponent;
  @ViewChild('azimuthError') azimuthError: FieldWriteNumberComponent;
  @ViewChild('rangeError') rangeError: FieldWriteNumberComponent;
  @ViewChild('heightError') heightError: FieldWriteNumberComponent;
  @ViewChild('elevationError') elevationError: FieldWriteNumberComponent;
  @ViewChild('SSRAzimuthError') SSRAzimuthError: FieldWriteNumberComponent;
  @ViewChild('SSRRangeError') SSRRangeError: FieldWriteNumberComponent;
  @ViewChild('rangeRateError') rangeRateError: FieldWriteNumberComponent;
  @ViewChild('coords') coords: CoordsComponent;
  @ViewChild('altitude') altitude: FieldWriteNumberComponent;

  public sensor: SensorCoreObject;
  public isCreating: boolean = false;

  public dimension: number = 0;

  // animations for collapsables
  public activeAnim: Array<Array<boolean>> = [[], [], [], [], []];
  public stateAnim: boolean = false;

  // ssr stuff
  SSRCheckBoxCallBack = (data: any): void => {
    this.ssrOnOff(data.checked);
  }

  PSRRegCheckBoxCallBack = (data: any): void => {
    this.psrRegReq(data.checked);
  }

  ALTRegCheckBoxCallBack = (data: any): void => {
    this.altRegReq(data.checked);
  }

  LocConfCheckBoxCallBack = (data: any): void => {
    // this.locConfReq(data.checked);
  }

  SSRRegCheckBoxCallBack = (data: any): void => {
    if (this.SSRCapable.getValue())
      this.locConfReq(data.checked);
  }

  // public panelOpenState: Array<boolean> = [false, false, false];
  public showUpdateButt: Array<boolean> = [];

  constructor(protected msgBox: MsgBoxService, public dialogRef: MatDialogRef<AroSensorTabDetailsComponent>, elementRef: ElementRef) {
    super(elementRef);
    userSettings.halfSecInter.subscribe(x => {
      this.stateAnim = x;
    });
  }

  ngOnInit(): void {
    this.windowClick();
  }

  ngAfterViewInit() {
    if (this.sensor) {
      this.dimension = this.sensor.is2D ? 0 : 1;
      this.ssrOnOff(this.sensor.SSRCapable);
      this.psrRegReq(this.sensor.PSRReg);
      this.altRegReq(this.sensor.ALTReg);
      this.locConfReq(this.sensor.locConfidence);
      if (this.sensor.SSRCapable)
        this.ssrRegReq(this.sensor.SSRReg);
      else
        this.ssrRegReq(false);

      this.sensor.ObjectUpdate.subscribe(x => {
        this.logiConn.CheckBoxUserVal = this.sensor.logiConn;
      });
    }
    else {
      this.sac.Form.controls.Field.setValue(17);
      this.ssrOnOff(false);
      this.psrRegReq(false);
      this.altRegReq(false);
      this.ssrRegReq(false);
      this.locConfReq(false);
    }
  }

  refresh(sensor: SensorCoreObject): void {
  }

  static createDialogConfig(upperBarHeight: number) {
    return utils.createDialogConfig(false, false, AroSensorTabDetailsComponent.DIALOG_ID,
      { top: `${upperBarHeight + 5}px`, right: `80px` });
  }

  updateNow() {
    let sensormsg = new msgs.SetSensor();
    let pass: boolean = true;
    if (this.sensor) {
      sensormsg.Sic = this.sensor.sic;
      sensormsg.Sac = this.sensor.sac;
    }
    else {
      sensormsg.Sic = this.sic.getValue();
      sensormsg.Sac = this.sac.getValue();
      if (sensormsg.Sic == undefined || sensormsg.Sac == undefined)
        pass = false;
      else {
        let sns = sensorsPool.getSensorBySicSac(sensormsg.Sic, sensormsg.Sac);
        if (sns) {
          this.sic.setError();
          this.sac.setError();
        }
      }
    }

    // if (this.sensor) {
    //   if (this.sensor.is2D != (this.dimension ? false : true))
        // sensormsg.Dimension = this.dimension ? false : true;
    // }
    // else
      // sensormsg.Dimension = this.dimension ? false : true;

    // sensormsg.LogicallyConnected = this.logiConn.getValue();
    // if (sensormsg.LogicallyConnected == undefined)
    //   pass = false;

    // sensormsg.Letter = this.sensorLetter.getValue();
    // if (sensormsg.Letter == undefined)
    //   pass = false;

    // sensormsg.Name = this.sensorName.getValue();
    // if (sensormsg.Name == undefined)
    //   pass = false;

    // if (!this.coords.eORbButtonSwitch) {
    //   if (this.coords.checkFormLoc())
    //     pass = false;
    //   let loc: Point = this.coords.readFormLoc();
    //   if (loc) {
    //     sensormsg.LocationLat = loc.y * DEG_TO_RAD;
    //     sensormsg.LocationLong = loc.x * DEG_TO_RAD;
    //   }
    //   else
    //     pass = false;
    // }

    // sensormsg.LocationAltitude = this.altitude.getValue();
    // if (sensormsg.LocationAltitude == undefined)
    //   pass = false;
    // else
    //   sensormsg.LocationAltitude *= 1000;

    // let val = this.scanTime.getValue();
    // if (val == undefined)
    //   pass = false;
    // else
    //   sensormsg.ScanTime = val * 1000;

    // sensormsg.MinRange = this.minRange.getValue();
    // sensormsg.MaxRange = this.maxRange.getValue();
    // if (sensormsg.MinRange == undefined)
    //   pass = false;
    // else {
    //   if (sensormsg.MaxRange != undefined) {
    //     if (sensormsg.MinRange > sensormsg.MaxRange) {
    //       this.minRange.setError();
    //       this.maxRange.setError();
    //       sensormsg.MinRange = undefined;
    //       sensormsg.MaxRange = undefined;
    //       pass = false;
    //     }
    //   }
    //   if (this.sensor) {
    //     if (sensormsg.MinRange > this.sensor.maxRange) {
    //       this.minRange.setError();
    //       sensormsg.MinRange = undefined;
    //       pass = false;
    //     }
    //   }
    // }
    // if (sensormsg.MaxRange == undefined)
    //   pass = false;
    // else {
    //   if (sensormsg.MinRange != undefined) {
    //     if (sensormsg.MaxRange < sensormsg.MinRange) {
    //       this.minRange.setError();
    //       this.maxRange.setError();
    //       sensormsg.MinRange = undefined;
    //       sensormsg.MaxRange = undefined;
    //       pass = false;
    //     }
    //   }
    //   if (this.sensor) {
    //     if (sensormsg.MaxRange < this.sensor.minRange) {
    //       this.maxRange.setError();
    //       sensormsg.MaxRange = undefined;
    //       pass = false;
    //     }
    //   }
    // }

    // sensormsg.MaxHeight = this.maxHeight.getValue();
    // if (sensormsg.MaxHeight == undefined)
    //   pass = false;

    // sensormsg.SSRCapable = this.SSRCapable.getValue();
    // if (sensormsg.SSRCapable) {
    //   sensormsg.SSRMinRange = this.SSRMinRange.getValue();
    //   sensormsg.SSRMaxRange = this.SSRMaxRange.getValue();
    //   if (sensormsg.MinRange == undefined)
    //     pass = false;
    //   else {
    //     if (sensormsg.SSRMaxRange != undefined) {
    //       if (sensormsg.SSRMinRange > sensormsg.SSRMaxRange) {
    //         this.SSRMinRange.setError();
    //         this.SSRMaxRange.setError();
    //         sensormsg.SSRMinRange = undefined;
    //         sensormsg.SSRMaxRange = undefined;
    //         pass = false;
    //       }
    //     }
    //     if (this.sensor) {
    //       if (sensormsg.SSRMinRange > this.sensor.SSRMaxRange) {
    //         this.SSRMinRange.setError();
    //         sensormsg.SSRMinRange = undefined;
    //         pass = false;
    //       }
    //     }
    //   }
    //   if (sensormsg.SSRMaxRange == undefined)
    //     pass = false;
    //   else {
    //     if (sensormsg.SSRMinRange != undefined) {
    //       if (sensormsg.SSRMaxRange < sensormsg.SSRMinRange) {
    //         this.SSRMinRange.setError();
    //         this.SSRMaxRange.setError();
    //         sensormsg.SSRMinRange = undefined;
    //         sensormsg.SSRMaxRange = undefined;
    //         pass = false;
    //       }
    //     }
    //     if (this.sensor) {
    //       if (sensormsg.SSRMaxRange < this.sensor.SSRMinRange) {
    //         this.SSRMaxRange.setError();
    //         sensormsg.SSRMaxRange = undefined;
    //         pass = false;
    //       }
    //     }
    //   }

    //   sensormsg.SSRRangeError = this.SSRRangeError.getValue();
    //   if (sensormsg.SSRRangeError == undefined)
    //     pass = false;

    //   val = this.SSRAzimuthError.getValue()
    //   if (val == undefined)
    //     pass = false;
    //   else
    //     sensormsg.SSRAzimuthError = val * DEG_TO_RAD;
    // }

    // sensormsg.PSRRegistration = this.PSRReg.getValue();
    // sensormsg.SSRRegistration = this.SSRReg.getValue();
    // sensormsg.ALTRegistration = this.ALT_REGISTERED.getValue();
    // sensormsg.AzimuthBias = this.azimuthBias.getValue();
    // if (sensormsg.AzimuthBias)
    //   sensormsg.AzimuthBias *= DEG_TO_RAD;
    // sensormsg.RangeBias = this.rangeBias.getValue();
    // sensormsg.HeightBias = this.heightBias.getValue();
    // sensormsg.ElevationBias = this.elevationBias.getValue();
    // if (sensormsg.ElevationBias)
    //   sensormsg.ElevationBias *= DEG_TO_RAD;
    // sensormsg.SSRAzimuthBias = this.SSRAzimuthBias.getValue();
    // if (sensormsg.SSRAzimuthBias)
    //   sensormsg.SSRAzimuthBias *= DEG_TO_RAD;
    // sensormsg.SSRRangeBias = this.SSRRangeBias.getValue();
    // sensormsg.LocXBias = this.locXBias.getValue();
    // sensormsg.LocYBias = this.locYBias.getValue();
    // sensormsg.LocConfidence = this.locConfidence.getValue();
    // sensormsg.LocBiasXError = this.locBiasXError.getValue();
    // sensormsg.LocBiasYError = this.locBiasYError.getValue();

    // val = this.azimuthError.getValue()
    // if (val == undefined)
    //   pass = false;
    // else
    //   sensormsg.AzimuthError = val * DEG_TO_RAD;

    // sensormsg.RangeError = this.rangeError.getValue();
    // if (sensormsg.RangeError == undefined)
    //   pass = false;

    // sensormsg.HeightError = this.heightError.getValue();
    // if (sensormsg.HeightError == undefined)
    //   pass = false;

    // val = this.elevationError.getValue()
    // if (val == undefined)
    //   pass = false;
    // else
    //   sensormsg.ElevationError = val * DEG_TO_RAD;

    // sensormsg.RangeRateError = this.rangeRateError.getValue();
    // if (sensormsg.RangeRateError == undefined)
    //   pass = false;

    // if (this.sensor || pass) {
    //   AppInjector.get(UserActionService).sendUserAction(sensormsg);
    //   if (!this.sensor)
    //     this.dialogClosed();
    // }
  }

  onNatNaiBtnClick(index) {
    this.sensor.naiNatArray[index].isVisible = !this.sensor.naiNatArray[index].isVisible;
    this.sensor.isNatNaiVisible = true;
    this.sensor.notifyDataChange();
  }

  selectOrRemoveAllNatNai(isChecked) {
    this.sensor.naiNatArray.forEach(item => {
      item.isVisible = isChecked;
    });
    this.sensor.isNatNaiVisible = isChecked;
    this.sensor.notifyDataChange();
  }

  async deleteSelectedNatNai() {
    let confirmed = await this.msgBox.showConfirmMsgBox("Are you sure you want to delete the selected Nats and Nais?", "Delete Nat Nai", "Yes", "No");
    if (!confirmed)
      return;

    // let naiNat = new AlertPolygonDialogComponent(null, null, null);
    let len = this.sensor.naiNatArray.length;
    for (let i = 0; i < len; i++) {
      if (this.sensor.naiNatArray[i].isVisible) {
        // naiNat.deleteNatNai(this.naiNatArray[i].naiNatId, this.sic, this.sac);
        let alertPolygonObj: AlertPolygonObject = new AlertPolygonObject();
        let obj = new projMsgs.Nai();
        alertPolygonObj.NaiOrNat = this.sensor.naiNatArray[i].naiOrNat;
        alertPolygonObj.Sic = this.sensor.naiNatArray[i].sic;
        alertPolygonObj.Sac = this.sensor.naiNatArray[i].sac;
        alertPolygonObj.NaiNatId = this.sensor.naiNatArray[i].naiNatId;
        alertPolygonObj.OperationAction = projEnums.NatNaiOperationAction.Delete;
        obj.AlertPolygonObj = alertPolygonObj;
        AppInjector.get(UserActionService).sendUserAction(obj);
      }
    }
  }

  ssrOnOff(val: boolean) {
    if (val) {
      this.SSRMinRange.enable();
      this.SSRMaxRange.enable();
      this.SSRAzimuthBias.enable();
      this.SSRAzimuthError.enable();
      this.SSRRangeBias.enable();
      this.SSRRangeError.enable();
    }
    else {
      this.SSRMinRange.disable();
      this.SSRMaxRange.disable();
      this.SSRAzimuthBias.disable();
      this.SSRAzimuthError.disable();
      this.SSRRangeBias.disable();
      this.SSRRangeError.disable();
    }
  }

  psrRegReq(val: boolean) {
    if (val && !this.sensor) {
      this.azimuthBias.resetValidators(true);
      this.rangeBias.resetValidators(true);
    }
    else {
      this.azimuthBias.resetValidators(false);
      this.rangeBias.resetValidators(false);
    }
  }

  altRegReq(val: boolean) {
    if (val && !this.sensor) {
      this.heightBias.resetValidators(true);
      this.elevationBias.resetValidators(true);
    }
    else {
      this.heightBias.resetValidators(false);
      this.elevationBias.resetValidators(false);
    }
  }

  ssrRegReq(val: boolean) {
    if (val && !this.sensor) {
      this.SSRAzimuthBias.resetValidators(true);
      this.SSRRangeBias.resetValidators(true);
    }
    else {
      this.SSRAzimuthBias.resetValidators(false);
      this.SSRRangeBias.resetValidators(false);
    }
  }

  locConfReq(val: boolean) {
    if (val && !this.sensor) {
      this.locXBias.resetValidators(true);
      this.locYBias.resetValidators(true);
    }
    else {
      this.locXBias.resetValidators(false);
      this.locYBias.resetValidators(false);
    }
  }

  collapsableAnimController(index: number, val: boolean) {
    if (val)
      this.activeAnim[index].push(true);
    else {
      if (this.activeAnim[index].length != 0) {
        this.activeAnim[index].pop();
      }
    }
  }
}
